import React from "react";
import { CiImageOn } from "react-icons/ci";
import { Header } from "../../components/header/Header";

export const ProfileViews = ({ user, images, preview }) => {
  return (
    <>
      {/* Header */}
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header title="Profile Details" showBack={true} />
      </header>

      <div className="w-full max-w-[1164px] mx-auto">
        {/* Profile Image */}
        <div className="w-full mt-9">
          <h2 className="text-black font-bold text-2xl">Profile Picture</h2>
          <p className="text-sm text-[#848484] mt-1">Your current profile picture</p>
        </div>

        <div className="w-full flex items-center border border-border_color rounded-[14px] mt-5 p-3 sm:py-5 sm:px-[26px] gap-10">
          <div className="w-[128px] h-[128px] border border-secondary rounded-full p-2 flex items-center justify-center">
            <div className="relative w-[117px] h-[117px]">
              <div className="w-full h-full rounded-full bg-white overflow-hidden flex items-center justify-center">
                {preview || user?.image ? (
                  <img
                    src={preview || user?.image}
                    alt="Profile"
                    className="w-full h-full object-cover object-center"
                  />
                ) : (
                  <CiImageOn className="text-8xl text-gray-300" />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Personal Info */}
        <div className="w-full mt-9">
          <h2 className="text-black font-bold text-2xl">Personal Details</h2>
        </div>
        <div className="w-full mt-5 border border-border_color p-3 sm:py-5 sm:px-[26px] rounded-[14px]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
            <InputField label="Name" value={user?.name} />
            <InputField label="Username" value={user?.username} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
            <InputField label="Email" value={user?.email} />
            <InputField label="Location" value={user?.location} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
            <InputField label="Artist Type" value={user?.artist_type} />
            <InputField label="Years of Experience" value={user?.experience} />
          </div>

          {/* Skills */}
          <div className="mb-[10px]">
            <label className="block text-lable_color font-bold mb-2">Skills</label>
            <div className="flex flex-wrap gap-2">
              {user?.skills?.map((skill, idx) => (
                <span
                  key={idx}
                  className="border border-primary text-primary px-3 py-1 rounded-3xl text-sm font-bold"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>

          {/* Bio */}
          <div>
            <label className="block text-lable_color font-bold mb-1">Bio</label>
            <textarea
              value={user?.bio}
              readOnly
              rows={4}
              className="w-full resize-none p-3 rounded-xl border border-border_color bg-gray-50 text-[#201D1D] text-[16px] font-medium outline-none"
            />
          </div>
        </div>

        {/* Recent Work */}
        <div className="w-full mt-9 ">
          <h2 className="text-black font-bold text-2xl">Recent Work</h2>
        </div>
        <div className="w-full mt-9 border border-border_color p-3 sm:py-[10px] sm:px-[26px] rounded-[14px] mb-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {images?.map((img, idx) => (
              <div key={idx} className="w-full h-80">
                <img
                  src={img}
                  alt="Gallery"
                  className="w-full h-full object-cover rounded-sm shadow-md hover:opacity-90 transition"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

// Reusable Input Component
const InputField = ({ label, value }) => (
  <div className="flex flex-col">
    <label className="block text-lable_color font-bold mb-1">{label}</label>
    <input
      type="text"
      value={value || ""}
      readOnly
      className="w-full px-3 py-[14px] bg-gray-50 border text-[#201D1D] text-[16px] font-medium border-border_color rounded-xl outline-none"
    />
  </div>
);
